export enum PredictionResult {
  TruePositive = 'true_positive',
  FalsePositive = 'false_positive',
}
